export const basicDetail = [
  {
    name: "affiliateName",
    disabled: true,
    rule: { required: false },
    label: "Affiliate Name",
    type: "text",
  },
  {
    name: "startDate",
    disabled: true,
    rule: { required: false },
    label: "Start Date",
    type: "date",
  },
  {
    name: "endDate",
    disabled: true,
    rule: { required: false },
    label: "End Date",
    type: "date",
  },
  {
    name: "invoiceDate",
    disabled: true,
    rule: { required: false },
    label: "Invoice Date",
    type: "date",
  },
  {
    name: "dueDate",
    rule: { required: false },
    label: "Due Date",
    type: "date",
  },
  {
    name: "invoiceStatus",
    rule: {
      required: "Status is required",
    },
    label: "Status",
    type: "dropdown",
  },
  {
    name: "totalCommissionAmount",
    rule: { required: false },
    label: "Total Commission Amount",
    type: "text",
  },
  {
    name: "confirmedReservationCount",
    disabled: true,
    rule: { required: false },
    label: "Confirmed Reservations",
    type: "number",
  },
  {
    name: "confirmedReservationAmount",
    disabled: true,
    rule: { required: false },
    label: "Confirmed Amount",
    type: "text",
  },
  {
    name: "cancelledReservationCount",
    disabled: true,
    rule: { required: false },
    label: "Cancelled Reservations",
    type: "number",
  },
  {
    name: "cancelledReservationAmount",
    disabled: true,
    rule: { required: false },
    label: "Cancelled Amount",
    type: "text",
  },
  {
    name: "noshowReservationCount",
    disabled: true,
    rule: { required: false },
    label: "No-Show Reservations",
    type: "number",
  },
  {
    name: "noshowReservationAmount",
    disabled: true,
    rule: { required: false },
    label: "No-Show Amount",
    type: "text",
  },
  {
    name: "additionalInfo",
    disabled: true,
    rule: { required: false },
    label: "Additional Info",
    type: "text",
  },
];

export const editMode = [
  {
    name: "modifiedDate",
    disabled: true,
    rule: { required: false },
    label: "Mod Time",
    type: "text",
  },
  {
    name: "modifiedBy",
    disabled: true,
    rule: { required: false },
    label: "Mod By",
    type: "text",
  },
];

export const statusDD = [
  { id: "draft", name: "Draft" },
  { id: "sent", name: "Sent" },
  { id: "void", name: "Void" },
  { id: "paid", name: "Paid" },
  { id: "partial_paid", name: "Partial Paid" },
];
